"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHydrationData = exports.withHydrate = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const isSSR = !(typeof window != 'undefined' && window.document);
let hydrationData = [];
// Context to keep track if HOC is applied higher up
const withHydratePresence = (0, react_1.createContext)(false);
function withHydrate(WrappedComponent, componentName, type) {
    const ComponentwithHydrate = (props) => {
        const hocAlreadyApplied = (0, react_1.useContext)(withHydratePresence);
        const [isClient, setIsClient] = react_1.default.useState(false);
        // TODO: this should be a hash of the props?
        const id = `hydrate_${(0, uuid_1.v4)()}`;
        react_1.default.useEffect(() => {
            setIsClient(true);
        }, []);
        switch (type) {
            case 'client': {
                // We check if we are on the server and the HOC is not already applied
                if (isSSR && !hocAlreadyApplied) {
                    hydrationData.push({ id, name: componentName, props: JSON.stringify(props), type });
                    const componentWithHoc = react_1.default.createElement(withHydratePresence.Provider, { value: true }, null);
                    // We return a relay-component with the id and the component with the HOC applied
                    return react_1.default.createElement('relay-component', { id }, componentWithHoc);
                }
                // We check if we are on the client and the HOC is already applied then we render the component
                // Otherwise we render nothing
                if (isClient) {
                    return react_1.default.createElement(WrappedComponent, props);
                }
                else {
                    return react_1.default.createElement(react_1.default.Fragment, null);
                }
            }
            case 'hybrid': {
                // We check if we are on the server and the HOC is not already applied
                if (isSSR && !hocAlreadyApplied) {
                    hydrationData.push({ id, name: componentName, props: JSON.stringify(props), type });
                    const componentWithHoc = react_1.default.createElement(withHydratePresence.Provider, { value: true }, react_1.default.createElement(WrappedComponent, props));
                    // We return a relay-component with the id and the component with the HOC applied
                    return react_1.default.createElement('relay-component', { id }, componentWithHoc);
                }
                // We SSR the component
                return react_1.default.createElement(WrappedComponent, props);
            }
        }
    };
    ComponentwithHydrate.displayName = `withHydrate(${componentName})`;
    return ComponentwithHydrate;
}
exports.withHydrate = withHydrate;
function getHydrationData() {
    const data = [...hydrationData];
    hydrationData = [];
    return data;
}
exports.getHydrationData = getHydrationData;
//# sourceMappingURL=withHydrate.js.map